import React, { useState } from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import useStatusThunk from "../../../hook/useStatusThunk";
import DisplayError from "../../dumb/DisplayError";
import { deleteTranslations } from "../../../redux/ducks/task";


const DeleteTranslations = props => {
    const [show, hide, renderModal] = useModal();
    const [d_deleteTranslations, status, error, event] = useStatusThunk(deleteTranslations);


   const deleteTr = () => {
        if (props.selectedTasks.length > 0) {
        d_deleteTranslations({ taskIDs: props.selectedTasks, projectID: props.projectID })
         }  
     }
    event.onSuccess = () => {
        hide();
    }

    return (
        <React.Fragment>
            <button className={"button button--primary " + props.className} onClick={show}>Delete Translations</button>

            {renderModal(
                <React.Fragment>
                    <div className="group">
                        <DisplayError error={error} />
                    </div>
                    <p className="info-block"> All translations from the selected tasks will be deleted.</p>

                    <LoadingButton loading={status == "pending"} className="button--primary" onClick={() => deleteTr()}>Delete All Translations?</LoadingButton>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default DeleteTranslations;